import api from '../';

class SubscriptionsApi {
    static list(params) {
        return api.axios.get('/subscriptions', { params }).then(response => response.data);
    }

    static create(params) {
        return api.axios.post('/subscriptions', params).then(response => response.data);
    }

    static delete(id) {
        return api.axios.delete('/subscriptions/' + id).then(response => response.data);
    }

    static update(params) {
        return api.axios.put('/subscriptions/' + params.id, params.subscription).then(response => response.data);
    }

    static show(id) {
        return api.axios.get('/subscriptions/' + id).then(response => response.data);
    }
}

export default SubscriptionsApi;
